import { useState, useEffect } from "react";
import { fetchAPI } from "../config/api";

export const usePlayerStats = (playerId, year) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!playerId) {
      setStats(null);
      return;
    }
    const controller = new AbortController();
    setLoading(true);
    fetchAPI(`/reports/longball_stats?player_id=${playerId}&year=${year || new Date().getFullYear()}`, {
      signal: controller.signal,
    })
      .then((data) => setStats(data))
      .catch(() => {})
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, [playerId, year]);

  return { stats, loading };
};
